export const getLocaleDateString = (dateStr: unknown): string | undefined => {
  if (dateStr instanceof Date || typeof dateStr === 'string') {
    const date = new Date(dateStr);
    if (!isNaN(date.getTime())) {
      return date.toLocaleDateString('en-CA');
    }
  }
};
